import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";

@Component({
    selector: "rask-violversion-selector",
    templateUrl: "./violversion-selector.component.html",
    styleUrls: ["./violversion-selector.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RadiobuttonGroupComponent,
        FormsModule
    ]
})
export class ViolversionSelectorComponent implements OnChanges {

    @Input() kontrakt: any;
    @Input() disabled: boolean;

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output("violVersionChanged") violVersionChanged = new EventEmitter();

    violVersion= "false";
    activetypes: IRadiobuttonItem[] = [
        { key: "false",
            value: "Viol 2" },
        { key: "true",
            value: "Viol 3" }
    ];

    ngOnChanges() {
        if(this.kontrakt.viol3) {
            this.violVersion = "true";
        } else {
            this.violVersion = "false";
        }
    }

    changeViolversion() {
        if(this.violVersion === "true") {
            this.kontrakt.viol3 = true;
        } else {
            this.kontrakt.viol3 = false;
        }
    }

    changeVersion(event: any) {
        this.violVersionChanged.emit(this.kontrakt);
    }

}
